import { createAsyncThunk } from '@reduxjs/toolkit';
import { _billingUrls, _priceUrls } from '@custom/Utils/constants/apiUrls';

interface EditPackagePayload {
  hospitalId: string;
  uniqueCode: string;
  updatedPackageData: {
    "Package Name": string;
    "Services Included": string;
    "Price": number;
    "Additional Info"?: string;
  };
}

const editInvestigation = createAsyncThunk(
  'editInvestigation',
  async (payload: EditPackagePayload, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${_billingUrls.editInvestigation}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update billing package');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default editInvestigation;
